import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

/**
 * cancelFindingsQueries will cancel all queries related to findings
 * (findings, total counts, and counts). Cancelling means that these
 * queries will not fetch in the background, and will need to be resumed
 * either by refreshing the page or using `useInvalidateFindings`.
 * This is useful when we update a findings, but we want to wait to invalidate
 * the queries to show the user other triaging information/options.
 */
export const useCancelFindingsQueries = () => {
  const queryClient = useQueryClient();

  const cancelFindingsQueries = useCallback(() => {
    queryClient.cancelQueries({
      queryKey: ["DeploymentFindings"],
    });
    queryClient.cancelQueries({
      queryKey: ["TotalFindingCounts"],
    });
    queryClient.cancelQueries({
      queryKey: ["FindingCounts"],
    });
  }, [queryClient]);

  return { cancelFindingsQueries };
};
